import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

const MONO = `ui-monospace, SFMono-Regular, Menlo, Monaco, 'Cascadia Mono', 'Roboto Mono', monospace`;

export const StyledMcpUseCases = styled.section`
	max-width: 1240px;
	margin: 0 auto;
	padding: 60px 20px;
	color: ${CSSVars.white};

	@media screen and (min-width: ${CSSVars.breakpointMD}) {
		padding: 80px 40px;
	}

	.head {
		text-align: center;
		max-width: 760px;
		margin: 0 auto 56px;
	}

	.eyebrow {
		display: inline-block;
		font-family: ${MONO};
		font-size: ${CSSVars.fontSizeXS};
		font-weight: 500;
		letter-spacing: 2px;
		text-transform: uppercase;
		color: ${CSSVars.blue300};
		margin-bottom: 16px;
	}

	h3 {
		font-size: ${CSSVars.fontSize2XL};
		margin-bottom: 16px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSize3XL};
		}

		.highlight {
			background: linear-gradient(270deg, #ff979c 0%, #4c4fff 100%);
			-webkit-background-clip: text;
			background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}

	.head p {
		font-size: ${CSSVars.fontSizeMD};
		font-weight: 300;
		color: ${CSSVars.gray300};
	}

	.grid {
		display: grid;
		grid-template-columns: 1fr;
		gap: 20px;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			grid-template-columns: repeat(2, 1fr);
		}

		@media screen and (min-width: ${CSSVars.breakpointLG}) {
			grid-template-columns: repeat(3, 1fr);
		}
	}

	.card {
		display: flex;
		flex-direction: column;
		border: 2px solid #1c1c20;
		border-radius: 10px;
		background: linear-gradient(
			-175deg,
			rgba(24, 24, 28, 1) 0%,
			rgba(0, 0, 0, 1) 100%
		);
		padding: 28px 26px;
		transition: transform 0.25s ease, border-color 0.25s ease;

		&:hover {
			transform: translateY(-4px);
			border-color: ${CSSVars.blue700};
		}

		.icon {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 46px;
			height: 46px;
			border-radius: 12px;
			background: rgba(76, 79, 255, 0.1);
			border: 1px solid rgba(76, 79, 255, 0.28);
			margin-bottom: 18px;

			svg {
				width: 22px;
				height: 22px;
				stroke: ${CSSVars.blue300};
				fill: none;
			}
		}

		h4 {
			font-size: ${CSSVars.fontSizeLG};
			font-weight: 600;
			margin-bottom: 8px;
		}

		.outcome {
			font-size: ${CSSVars.fontSizeSM};
			font-weight: 300;
			line-height: 1.6;
			color: ${CSSVars.gray300};
			margin-bottom: 18px;
		}

		.tags {
			display: flex;
			flex-wrap: wrap;
			gap: 8px;
			margin-bottom: 20px;

			span {
				font-size: ${CSSVars.fontSizeXS};
				color: ${CSSVars.gray100};
				background: rgba(255, 255, 255, 0.04);
				border: 1px solid #2a2c52;
				border-radius: 7px;
				padding: 5px 10px;
			}
		}

		.prompt {
			margin-top: auto;
			display: flex;
			align-items: baseline;
			gap: 8px;
			font-family: ${MONO};
			font-size: ${CSSVars.fontSizeSM};
			line-height: 1.5;
			color: ${CSSVars.gray300};
			background: #0c0d1c;
			border: 1px solid #23254a;
			border-radius: 9px;
			padding: 12px 13px;

			&::before {
				content: '›';
				color: ${CSSVars.pink300};
				font-weight: 700;
			}
		}
	}
`;
